export const COMPONENT_NAME = "admin-application-edit";
